<template>
  <div class="Wdgt-Auth-Module">
    <p class="Wdgt-Auth-Module__text Wdgt-Auth-Module__text--thin">Мы отправили Вам письмо. Пожалуйста, свяжитесь с нами, если Вы не получили его в течение нескольких минут.</p>
    <ButtonMain class="Wdgt-Auth-Module__button" :width="'100%'" @click="toClose">Продолжить</ButtonMain>
  </div>
</template>

<script setup>
  import { useStore } from 'vuex';
  import DROPDOWN_NAMES from '@shared/constants/dropdowns/dropdownsName.js';
  //----------------------------
  import ButtonMain from '@shared/UI/Buttons/ButtonMain/ButtonMain.vue';
  //----------------------------
  const store = useStore();
  //--------------------------------
  const POPUP_NAME = DROPDOWN_NAMES.auth;
  //--------------------------------
  //Закрыть виджет
  const toClose = () => store.dispatch('Dropdowns/removeTheDropdown', POPUP_NAME);
</script>

<style lang="scss">
  @import '../../styles/Wdgt-Auth-Module.scss';
</style>
